import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/marketing/CTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/marketing/Features.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/marketing/NewHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayeredCard"] */ "/vercel/path0/apps/web/src/components/ui/BackgroundLayers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.12_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-dom@19_wwvjpr6q4sl2ev7cgu5kpxmg4u/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.12_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_react-dom@19_wwvjpr6q4sl2ev7cgu5kpxmg4u/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
